import { ArrowUpward } from "@mui/icons-material";
import { Avatar, Box, Divider, Grid, Stack, Typography } from "@mui/material";
import PlayCircleFilledWhiteIcon from "@mui/icons-material/PlayCircleFilledWhite";
import EastIcon from "@mui/icons-material/East";
import { motion } from "framer-motion";
function BlogSection() {
  const questions = [
    "How do you estimate project timelines?",
    "How do you estimate project timelines?",
    "How is stack different from queue?",
  ];
  const services = [
    "Game <br/> Development",
    "Software <br/> Development",
    "Web <br/> Development",
    "UI/UX <br/> Designing",
    "Marketing & Adver- <br/>tising Design",
    "ILLustration",
    "Data Analytics",
    "Machine Learning",
    "Content <br/> Marketing",
  ];
  const TypographyMotion = motion(Typography);
  const AvatarMotion = motion(Avatar);
  const EastIconMotion = motion(EastIcon);
  const GridMotion = motion(Grid);
  const BoxMotion = motion(Box);
  const StackMotion = motion(Stack);
  return (
    <Stack
      direction="column"
      sx={{ justifyContent: "center", alignItems: "center", pb: "5rem" }}
    >
      <Box
        sx={{
          //   height: "60rem",
          //   backgroundColor: "#857f7f6e",
          width: "85%",
          my: "8rem",
        }}
      >
        <Grid container gap={1.2} justifyContent="center">
          <Grid item xs={12} sm={12} md={11} lg={11}>
            <TypographyMotion
              initial={{ opacity: 0, y: -90 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 1 }}
              variant="h3"
              sx={{ fontWeight: "800", pb: "2rem" }}
            >
              BLOG
            </TypographyMotion>
          </Grid>
          <GridMotion
            initial={{ opacity: 0, scale: 0.8 }} // Start smaller
            whileInView={{ opacity: 1, scale: 1 }} // Grow to full size
            viewport={{ once: true, amount: 0.1 }}
            transition={{ duration: 1 }}
            item
            xs={12}
            sm={12}
            md={5}
            lg={5}
            sx={{
              //   height: "50rem",
              borderRadius: "3rem",
              backgroundImage: `url('/images/designpicture.avif')`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              position: "relative",
            }}
          >
            <Box
              sx={{
                width: "27rem",
                // height: "8rem",
                background: "white",
                clipPath:
                  "polygon(0 0, 80% 0, 80% 50%, 100% 50%, 100% 100%, 0 100%)",
                position: "absolute",
                left: -1,
                bottom: -1,
                padding: ".5rem",

                fontSize: "1rem",
              }}
            >
              <TypographyMotion
                initial={{ opacity: 0, x: -100 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, amount: 0.1 }}
                transition={{ duration: 1 }}
                variant="subtitle2"
                sx={{ fontWeight: "600", pb: ".5rem" }}
              >
                Category .{" "}
                <span style={{ fontWeight: "100" }}>Graphic Design | </span>
                <span
                  style={{
                    fontWeight: "100",
                    // fontSize: "1rem",
                    // color: "#b9b9b9",
                    color: "#8f8f8f",
                  }}
                >
                  Nov 2024
                </span>
              </TypographyMotion>
              <TypographyMotion
                initial={{ opacity: 0, x: -100 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, amount: 0.1 }}
                transition={{ duration: 1 }}
                variant="h4"
                sx={{ fontWeight: "bold" }}
              >
                Designs that Leave <br /> a Lasting Impression !
              </TypographyMotion>
            </Box>
          </GridMotion>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={
              {
                //   height: "40rem",
              }
            }
          >
            <Stack direction="row" gap={1.5} flexWrap="wrap">
              <Stack
                id="Category.SoftwareDevelopment-Card"
                sx={{
                  borderRadius: "3rem",
                  width: "62%",
                  p: "2rem",
                  bgcolor: "black",
                  color: "white",
                  position: "relative",
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: "600", pb: "1.1rem" }}
                >
                  Category .{" "}
                  <span style={{ fontWeight: "100" }}>
                    Software Development{" "}
                  </span>
                </Typography>
                <TypographyMotion
                  initial={{ opacity: 0, scale: 0.8 }} // Start smaller
                  whileInView={{ opacity: 1, scale: 1 }} // Grow to full size
                  viewport={{ once: true, amount: 0.1 }}
                  transition={{ duration: 1 }}
                  variant="h4"
                  sx={{ fontWeight: "bold" }}
                >
                  conscisely convey their specialization or technical
                  proficiency!
                </TypographyMotion>
                <TypographyMotion
                  initial={{ opacity: 0, scale: 0.8 }} // Start smaller
                  whileInView={{ opacity: 1, scale: 1 }} // Grow to full size
                  viewport={{ once: true, amount: 0.1 }}
                  transition={{ duration: 1 }}
                  variant="body2"
                  sx={{ pt: "1rem" }}
                >
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ur labore et dolore magna
                  aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing
                  elit, sed do eiusmod tempor incididunt ur labore et dolore
                  magna aliqua...
                </TypographyMotion>
                {questions.map((question, i) => (
                  <>
                    <Divider
                      key={i}
                      sx={{
                        height: ".2rem",
                        bgcolor: "#ffffff",
                        mx: "-2rem",
                        my: "1rem",
                      }}
                    />
                    <Stack
                      key={i}
                      direction="row"
                      justifyContent="space-between"
                    >
                      <TypographyMotion
                        initial={{ opacity: 0, x: -150 }} // Start hidden and below
                        whileInView={{ opacity: 1, x: 0 }} // Animate into view
                        viewport={{ once: true, amount: 0.5 }} // Trigger animation when in view
                        transition={{
                          duration: 1, // Animation duration
                          delay: i * 0.5, // Stagger by 1 second for each card
                        }}
                        variant="subtitle1"
                      >
                        {question}
                      </TypographyMotion>
                      <EastIconMotion
                        initial={{ opacity: 0, x: 150 }} // Start hidden and below
                        whileInView={{ opacity: 1, x: 0 }} // Animate into view
                        viewport={{ once: true, amount: 0.5 }} // Trigger animation when in view
                        transition={{
                          duration: 1, // Animation duration
                          delay: i * 0.5, // Stagger by 1 second for each card
                        }}
                        role="button"
                        sx={{ cursor: "pointer" }}
                      />
                    </Stack>
                  </>
                ))}
                <AvatarMotion
                  initial={{ opacity: 0, y: -70 }} // Start hidden and below
                  whileInView={{ opacity: 1, y: 0 }} // Animate into view
                  viewport={{ once: true, amount: 0.5 }} // Trigger animation when in view
                  transition={{
                    duration: 1, // Animation duration
                  }}
                  variant="rounded"
                  sx={{
                    bgcolor: "black",
                    width: 52,
                    height: 52,
                    borderRadius: "50%",
                    border: ".5rem solid #ffffff",
                    position: "absolute",
                    right: 0,
                    top: 0,
                  }}
                >
                  <ArrowUpward
                    style={{
                      fontSize: 30,
                      color: "white",
                      transform: "rotate(45deg)",
                    }}
                  />
                </AvatarMotion>
              </Stack>
              <Stack
                id="Unleas-your-games"
                sx={{
                  borderRadius: "3rem",
                  width: "35%",
                  bgcolor: "#d9d9d9",
                  padding: "1.4rem",
                  position: "relative",
                }}
              >
                <TypographyMotion
                  initial={{ opacity: 0, x: 90 }} // Start hidden and below
                  whileInView={{ opacity: 1, x: 0 }} // Animate into view
                  viewport={{ once: true, amount: 0.5 }} // Trigger animation when in view
                  transition={{
                    duration: 1, // Animation duration
                  }}
                  variant="subtitle2"
                  sx={{ fontWeight: "600", pb: "1.4rem" }}
                >
                  Category .{" "}
                  <span style={{ fontWeight: "100" }}>Game Development</span>
                </TypographyMotion>
                <Typography
                  variant="subtitle2"
                  style={{
                    fontWeight: "100",
                    color: "#7c7c7c",
                  }}
                >
                  {" "}
                  Nov 2024
                </Typography>
                <TypographyMotion
                  initial={{ opacity: 0, scale: 0.5 }} // Start hidden and below
                  whileInView={{ opacity: 1, scale: 1 }} // Animate into view
                  viewport={{ once: true, amount: 0.5 }} // Trigger animation when in view
                  transition={{
                    duration: 1, // Animation duration
                  }}
                  variant="h4"
                  sx={{ fontWeight: "800" }}
                >
                  Unleash Your Inner Gamer!
                </TypographyMotion>
                <BoxMotion
                  initial={{ opacity: 0, scale: 0.8 }} // Start smaller
                  whileInView={{ opacity: 1, scale: 1 }} // Grow to full size
                  viewport={{ once: true, amount: 0.1 }}
                  transition={{ duration: 1 }}
                  component="img"
                  src="/images/unleash-gamer.png"
                  sx={{
                    width: "19rem",
                    height: "20rem",
                    position: "absolute",
                    left: 3,
                    bottom: 8,
                  }}
                ></BoxMotion>
              </Stack>
              <Stack
                id="view-all-categories"
                sx={{
                  borderRadius: "3rem",
                  bgcolor: "#d9d9d9",
                  width: "48%",
                  p: "1.2rem",
                }}
              >
                <Stack
                  direction="row"
                  flexWrap="wrap"
                  gap={1}
                  justifyContent="center"
                  minHeight="2rem"
                >
                  {services.map((service, i) => (
                    <StackMotion
                      initial={{ opacity: 0, x: 90 }} // Start hidden and below
                      whileInView={{ opacity: 1, x: 0 }} // Animate into view
                      viewport={{ once: true, amount: 0.5 }} // Trigger animation when in view
                      transition={{
                        duration: 1, // Animation duration
                        delay: 0.2 * i,
                      }}
                      key={i}
                      direction="column"
                      sx={{
                        minHeight: "2rem",
                        bgcolor: "#1e1e1e",
                        borderRadius: "5rem",
                        alignItems: "center",
                        justifyContent: "center",
                        mb: ".5rem",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#f2f2f2",
                          py: ".4rem",
                          textAlign: "center",
                          px: "1.6rem",
                          fontSize: ".7rem",
                        }}
                        variant="body2"
                        dangerouslySetInnerHTML={{ __html: service }}
                      ></Typography>
                    </StackMotion>
                  ))}
                </Stack>
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  pt="3.8rem"
                  pb="1rem"
                >
                  <TypographyMotion
                    initial={{ opacity: 0, y: 90 }} // Start hidden and below
                    whileInView={{ opacity: 1, y: 0 }} // Animate into view
                    viewport={{ once: true, amount: 0.5 }} // Trigger animation when in view
                    transition={{
                      duration: 1, // Animation duration
                    }}
                    variant="h6"
                    fontWeight="bold"
                  >
                    View All Categories
                  </TypographyMotion>
                  <EastIconMotion
                    initial={{ opacity: 0, x: 90 }} // Start hidden and below
                    whileInView={{ opacity: 1, x: 0 }} // Animate into view
                    viewport={{ once: true, amount: 0.5 }} // Trigger animation when in view
                    transition={{
                      duration: 1, // Animation duration
                    }}
                    role="button"
                    sx={{ cursor: "pointer" }}
                  />
                </Stack>
              </Stack>
              <Stack
                id="category-web-development"
                direction="column"
                sx={{
                  borderRadius: "3rem",
                  width: "49%",
                  backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('/images/design-box.avif')`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  opacity: "0.8",
                  px: "2rem",
                  py: "1rem",
                  color: "white",
                  justifyContent: "space-between",
                }}
              >
                <TypographyMotion
                  initial={{ opacity: 0, x: 100 }} // Start hidden and below
                  whileInView={{ opacity: 1, x: 0 }} // Animate into view
                  viewport={{ once: true, amount: 0.5 }} // Trigger animation when in view
                  transition={{
                    duration: 1, // Animation duration
                  }}
                  variant="subtitle2"
                  sx={{ fontWeight: "600", pb: "1.4rem" }}
                >
                  Category .{" "}
                  <span style={{ fontWeight: "100" }}>Web Development</span>
                </TypographyMotion>
                <AvatarMotion
                  initial={{ opacity: 0, scale: 0.4 }} // Start hidden and below
                  whileInView={{ opacity: 1, scale: 1 }} // Animate into view
                  viewport={{ once: true, amount: 0.5 }} // Trigger animation when in view
                  transition={{
                    duration: 0.6, // Animation duration
                  }}
                  sx={{ bgcolor: "#111111cf", alignSelf: "center" }}
                >
                  <PlayCircleFilledWhiteIcon />
                </AvatarMotion>
                <Box>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: "100",
                      color: "#7c7c7c",
                      pb: ".4rem",
                    }}
                  >
                    Nov 2024
                  </Typography>
                  <TypographyMotion
                    initial={{ opacity: 0, y: 80 }} // Start hidden and below
                    whileInView={{ opacity: 1, y: 0 }} // Animate into view
                    viewport={{ once: true, amount: 0.5 }} // Trigger animation when in view
                    transition={{
                      duration: 1, // Animation duration
                    }}
                    variant="subtitle2"
                    sx={{ fontWeight: "600" }}
                  >
                    Bridging Ideas, Building Websites
                  </TypographyMotion>
                </Box>
              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </Stack>
  );
}

export default BlogSection;
